// Utilitários de numeração do histórico de aditivos.
// Nº posicional: contrato original (não aditivo) = 1, depois os aditivos
// sequencialmente por ordem de vigência (dtFimVigencia asc).

export function ordenarHistoricoAditivos(historico) {
    return [...(historico || [])].sort((a, b) => {
        if (a.isAditivo !== b.isAditivo) return a.isAditivo - b.isAditivo
        return new Date(a.dtFimVigencia) - new Date(b.dtFimVigencia)
    })
}

// Mapa { idContrato -> Nº posicional }
export function mapaNumeroAditivoPorContrato(historico) {
    const mapa = {}
    ordenarHistoricoAditivos(historico).forEach((contrato, index) => {
        mapa[contrato.idContrato] = index + 1
    })
    return mapa
}

// Nº posicional do registro atualmente vigente (ou null)
export function numeroAditivoVigente(historico) {
    const ordenado = ordenarHistoricoAditivos(historico)
    const indice = ordenado.findIndex(contrato => contrato.contratoVigente)
    return indice >= 0 ? indice + 1 : null
}
